import React from 'react';

import { Form, Modal } from 'antd';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks/useNotification';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { CoachesSelector } from 'features/coaches';
import { CreateGroupeParams, useCreateGroupeMutation } from 'features/groups';
import { SelectUsers } from 'features/users';

type FormData = CreateGroupeParams;

interface Props {
  isModalOpen: boolean;
  handleCancel: () => void;
}

const initialValues = {
  surfaceType: 'clay',
  type: 'indoor',
};

const CreateModal = ({ isModalOpen, handleCancel }: Props) => {
  const [form] = Form.useForm<FormData>();
  const [create, { isSuccess, isError, isLoading, error }] = useCreateGroupeMutation();


  useNotification({
    isSuccess,
    isError,
    error,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel()
  });

  const onFinish = (values: FormData) => {
    create(values);
  };

  return (
    <Modal
      title={t('groups.title.create')}
      open={isModalOpen}
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={initialValues}
        className="edit-user__form"
      >
        <InputStr type='name' formProps={{ rules: [{ required: true }] }} />
        <InputStr type='price' formProps={{ rules: [{ required: true }] }} />
        <InputStr type='priceIndividual' formProps={{ rules: [{ required: true }] }} />
        <CoachesSelector oneSelectMode formProps={{ rules: [{ required: true }] }} />
        <SelectUsers />
        <SubmiteButton submiteText={t('table.create')} isLoading={isLoading} />
      </Form>
    </Modal>
  );
};

export default CreateModal;
